import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';
import Strings from '../../translations/Translations';
import Accordion from '../../Layout/Components/Accordion';

export default function Help() {
  const content = [
    {
      title: 'What is PCM?',
      content: 'PCM (PepBlast Campaign Manager) is a platform provided by PepBlast where you can create and manage campaigns.'
    },
    {
      title: 'What is a campaign?',
      content: 'A campaign is a collection of PepBlast Videos: create your campaign inserting your event data and create videos inside this campaign to engaje and grow your users.'
    },
    {
      title: 'What can I do with a Video?',
      content: 'You can create fun movies and slideshows with your pictures and music easily. Invite your fans to send photos and clips to your video. Personalize it with one of several amazing styles and animations.'
    },
    {
      title: 'Need more information?',
      content: 'Contact us at: info@photozig.com. PepBlast Campaign Manager was created by Photozig, Inc.'
    }
  ];

  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('help')}
          subheading={Strings('help_page_text')}
          icon="pe-7s-umbrella"
        />

        <Row>
          <Col sm="12">
            <Accordion
              content={content}
            />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
